import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeader } from "@/components/sections/SectionHeader";

const FAQS = [
  { q: "Livrați produse pentru HoReCa?", a: "Da. Lucrăm direct cu restaurante, cafenele, pizzerii, hoteluri, fast-food-uri și distribuitori. Construim împreună o schemă de livrare care funcționează pentru ritmul tău." },
  { q: "Aveți produse congelate?", a: "Da. Avem o gamă completă de produse congelate ready-to-bake: croissante, blaturi pizza, foietaje, trigoane, strudele și altele. Le coci la momentul potrivit, exact când ai nevoie." },
  { q: "Aveți produse gata coapte?", a: "Da. Pentru vitrine, cafenele și locații care vor produs finit, ambalat curat și gata de servit." },
  { q: "Care este diferența dintre produsele coapte și cele congelate?", a: "Cele coapte vin gata de servire. Cele congelate îți dau control total asupra momentului în care produsul ajunge cald, proaspăt, în fața clientului. Alegerea ține de ritmul și fluxul locației tale — putem discuta ce e mai potrivit pentru tine." },
  { q: "Pot cere o ofertă personalizată?", a: "Sigur. Spune-ne tip afacere, volum estimat, județ și produse de interes. Îți pregătim o ofertă potrivită." },
  { q: "Pentru ce tipuri de afaceri sunt potrivite produsele DOTAPAN?", a: "Restaurante, cafenele, hoteluri, pizzerii, fast-food-uri, brutării, magazine de cartier, lanțuri retail și distribuitori HoReCa." },
  { q: "Aveți blat pizza congelat?", a: "Da. Format 250g, elastic, ușor de lucrat, gustos după coacere. Una dintre cele mai apreciate poziții din portofoliul nostru." },
  { q: "Cum pot primi catalogul de produse?", a: "Trimite-ne datele tale prin formularul de contact sau pe WhatsApp la +40 740 433 894. Îți trimitem catalogul actualizat direct pe email." },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="section-pad bg-surface-2/40 border-y border-border">
      <div className="max-w-4xl mx-auto container-px">
        <SectionHeader eyebrow="Întrebări frecvente" title="Ce vrei să știi înainte să comanzi." align="center" testId="faq-header" />
        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} className="card-soft px-6 border-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display text-lg md:text-xl text-left text-text hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-text-soft leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
